import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getSourcingHandoff,
  pullHiringCompanies,
  syncTenderWinners,
} from '../api/sourcing';

export function useSourcingHandoff(statuses?: string[]) {
  return useQuery({
    queryKey: ['gtm-sourcing', 'handoff', statuses ?? ['new']],
    queryFn: () => getSourcingHandoff(statuses),
  });
}

/** Free: pull tender awards + roll winners into the list. Refreshes the handoff. */
export function useSyncTenderWinners() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: syncTenderWinners,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['gtm-sourcing'] });
    },
  });
}

/** Paid (TheirStack): pull companies hiring bid roles. Refreshes the handoff. */
export function usePullHiringCompanies() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (opts: { maxAgeDays?: number; pages?: number; perPage?: number } = {}) =>
      pullHiringCompanies(opts),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['gtm-sourcing'] });
    },
  });
}
